import React from 'react';
import { CSVLink } from 'react-csv';
import './ExportCSV.css';

function ExportCSV({ data, jobNumber }) {
  const headers = [
    { label: 'Pole', key: 'pole_name' },
    { label: 'Line', key: 'line_name' },
    { label: 'WF Crew', key: 'assigned_to_name' },
    { label: 'GPS', key: 'pole_lat' },
    { label: 'Address', key: 'street_address' },
    { label: 'Digsafe', key: 'dig_safe_required' },
    { label: 'NRA/DNR', key: 'nra_required' },
    { label: 'Status', key: 'status' },
    { label: 'Date Added', key: 'date_added' },
    { label: 'Date Completed', key: 'actual_date_completed' },
  ];

  const fileName = `job-${jobNumber}-tickets.csv`;

  return (
    <button type='button' className="export-csv-button" >
      <CSVLink data={data} headers={headers} filename={fileName}>
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px">
          <path d="M11.3705 10.384C10.7848 10.9698 10.7848 11.9195 11.3705 12.5053L11.4373 12.5721C12.0231 13.1579 12.9728 13.1579 13.5586 12.5721L16.6736 9.45707C16.8178 9.31284 16.9266 9.14656 16.9998 8.96907C16.9999 8.97936 17 8.98967 17 9V17C17 18.1046 16.1046 19 15 19H7C5.89543 19 5 18.1046 5 17V9C5 7.89543 5.89543 7 7 7L14.8511 7C14.7195 7.06882 14.5961 7.15848 14.4855 7.269L11.3705 10.384Z" fill="#ffffff"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2175 4.78249C19.4128 4.97776 19.4128 5.29434 19.2175 5.4896L12.8536 11.8536C12.6583 12.0488 12.3417 12.0488 12.1464 11.8536C11.9512 11.6583 11.9512 11.3417 12.1464 11.1465L18.5104 4.78249C18.7057 4.58723 19.0223 4.58723 19.2175 4.78249Z" fill="#ffffff"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M14 4.5C14 4.22386 14.2239 4 14.5 4H19.5C19.7761 4 20 4.22386 20 4.5V9.5C20 9.77614 19.7761 10 19.5 10C19.2239 10 19 9.77614 19 9.5V5H14.5C14.2239 5 14 4.77614 14 4.5Z" fill="#ffffff"/>
        </svg>
        <span>Export Tickets</span> 
      </CSVLink>
    </button>
  );
}

export default ExportCSV;